<template>
  <v-list-item dense :class="item.IsActive ? '' : 'deactivated'" @click="$emit('click')">
    <v-row no-gutters>
      <v-col cols="auto" class="pr-3 d-flex align-center">
        <v-icon size="20">$machine_categories</v-icon>
      </v-col>
      <v-col cols="0" class="d-flex align-center">
        {{ item.Name }}
      </v-col>
      <v-col v-if="preventiveMaintenanceEnabled && item.ServiceAgreement" :cols="isPhoneBool ? '12' : 'auto'" :class="isPhoneBool ? 'mt-2' : ''">
        <v-card :color="isPhoneBool ? '#ffffff69' : 'transparent'" class="py-1" :flat="!isPhoneBool">
          <v-row no-gutters justify="center" align="center" style="width: 330px; "
            :style="isPhoneBool ? '' : 'border-left: 1px solid rgb(227, 227, 227);'">
            <v-col cols="4" class="d-flex align-center">
              <v-icon size="22" class="mr-1">mdi-file-clock</v-icon>
              {{ $t('servicesystem.common_objects.service_agreement.deafault') }}
            </v-col>
            <v-col cols="8">
              <ServiceAgreementReocurrenceBar :agreement="item.ServiceAgreement">
              </ServiceAgreementReocurrenceBar>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-list-item>
</template>


<script>
import ServiceAgreementReocurrenceBar from '@/components/ServiceAgreementReocurrenceBar.vue';

export default {
  name: 'MachineTypeListItem',
  props: {
    item: Object,
  },
  components: {
    ServiceAgreementReocurrenceBar,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {
    preventiveMaintenanceEnabled() {
      return this.$store.state.GlobalSettings.PreventiveMaintenanceEnabled;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>